import React, { useCallback, useEffect, useState } from "react";
import CardTable from "../../../components/AdminTable/CardTable";
// import Dropdown from "../../../components/AdminDropdown/Dropdown";
import axios from "axios";
import { apiKey } from "../../../config/config";
import { FaEdit, FaTrashAlt } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { languageHelper } from "../../../config/helperFunctions";
import Dropdown from "../../../components/AdminDropdown/Dropdown";
import DeleteModal from "../../../components/Modal/DeleteModal";

function Tables() {
  const user = JSON.parse(localStorage.getItem("rms-admin"));
  const [pageLoading, setPageLoading] = useState(true);
  const [error, setError] = useState(false);
  const [columns] = useState([
    {
      header: languageHelper("SN") || "SN",
      accessorKey: "id",
    },
    {
      header: languageHelper("Table Name") || "Table Name",
      accessorKey: "name",
    },
    {
      header: languageHelper("Seat Capacity") || "Seat Capacity",
      accessorKey: "sit_capacity",
    },
    {
      header: languageHelper("Position") || "Position",
      accessorKey: "position",
    },
    {
      header: languageHelper("Description") || "Description",
      accessorKey: "description",
    },
    {
      header: languageHelper("Added By") || "Added By",
      cell: (row) => row.row.original?.user.name,
    },
    {
      header: languageHelper("Actions") || "Actions",
      accessorKey: "total",
      cell: (row) => (
        <Dropdown id={row.row.original.id} options={dropdownOptions} />
      ),
    },
  ]);
  const [data, setData] = useState([]);
  const [deleteId, setDeleteId] = useState(null);

  const navigate = useNavigate();

  const handleDelete = (id) => {
    axios
      .delete(`${apiKey}/api/rms/admin/tables/${id}`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
      })
      .then((res) => {
        toast.success(res.data.message || "Success", {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        fetchData();
        setDeleteId(null);
      })
      .catch((err) => {
        toast.error(err.response.data.message, {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      });
  };

  const dropdownOptions = [
    {
      name: languageHelper("Edit"),
      icon: <FaEdit />,
      func: (id) => {
        navigate(`AddDeliveryCompanyForm/${id}`);
      },
    },
    {
      name: languageHelper("Delete"),
      icon: <FaTrashAlt />,
      func: (id) => {
        setDeleteId(id);
      },
    },
  ];

  const [buttonData] = useState([
    {
      buttonText: languageHelper("Add Table"),
      path: "addTableForm",
    },
  ]);

  const fetchData = useCallback(() => {
    axios
      .get(`${apiKey}/api/rms/admin/tables`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
        params: {
          outletId: user?.user.outlet_id,
        },
      })
      .then((res) => {
        setData(res.data);
        setPageLoading(false);
      })
      .catch((err) => {
        setPageLoading(false);
        setError("Cannot load data");
      });
  }, [user?.token, user?.user.outlet_id]);

  useEffect(() => {
    setPageLoading(true);

    fetchData();
  }, [fetchData, user.token]);
  return (
    <main>
      <CardTable
        data={data}
        columns={columns}
        error={error}
        heading={languageHelper("Tables")}
        buttonData={buttonData}
      />
      {pageLoading && (
        <div className="absolute top-0 left-0 w-full h-full grid place-items-center">
          <img src="/assets/gif/dash2.gif" alt="" />
        </div>
      )}
      {deleteId && (
        <DeleteModal
          setIsOpen={setDeleteId}
          onDelete={() => handleDelete(deleteId)}
        />
      )}
    </main>
  );
}

export default Tables;
